import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { DropdownWithLabel } from '@blueprint/dropdown';
import { MultiColumnDropdownWithLabel } from '@blueprint/multicolumn-dropdown';

import { getRems } from './Layout.styles';

export const StyledDropdown = styled(DropdownWithLabel)(
    ({ theme: { spacing } }) => css`
        margin: ${spacing['8px']};
    `
);

export const StyledDropdownToRentPrice = styled(DropdownWithLabel)(
    () => css`
        min-width: ${getRems(240)};
    `
);

export const PropertyTypeRadioButtonWrapper = styled.div(
    () => css`
        display: flex;
        flex-wrap: wrap;
    `
);

export const AllDropdownsWrapper = styled.div(
    () => css`
        min-width: 28.525rem;
    `
);

export const MultiColumnDropdownWithLabelTravelTime = styled(
    MultiColumnDropdownWithLabel
)(
    () => css`
        border-left-width: 1px;
    `
);
